import Vue from "vue";
import Vuex from "vuex";
import jwt_decode from "jwt-decode";
import { userLogin, getPreference } from "../../utils/apiFunctions";
import { getAccessProjects, getProjectUrl } from "../../utils/helpers";
// import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser";

Vue.use(Vuex);

const state = () => ({
  accessToken: "",
  refreshToken: "",
  loggedUserName: "",
  preference: {},
  loginStatus: false,
  user: {
    userID: "",
    email: "",
  },
  // assessmenWindow:"",
  username: "",
  assessment: {},
  recruitment: {},
  candidate: {},
  training: {},
  collegeDashboard: {},
  candidateRedirect: {},
  paneluuid: null,
  loginData: {},
  userData: {},
  trainingRedirect: {},
  pageredirect: null,
  redirectBack: null,
  resumeClinicuuid: null,
  newUserUsingUUID: false,
  resumeJobid: null,
  mobileToken: null,
  notificationRedirect: null
});

const getters = {
  getNotificationRedirect: (state) => state.notificationRedirect,
  getMobileToken: (state) => state.mobileToken,
  getUserData: (state) => state.userData,
  getPageRedirect: (state) => state.pageredirect,
  getCandidateRedirect: (state) => state.candidateRedirect,
  getTrainingRedirect: (state) => state.trainingRedirect,
  getPanelId: (state) => state.paneluuid,
  getUserDetail: (state) => state.user,
  getPreference: (state) => state.preference,
  getUserName: (state) => state.loggedUserName,
  getLoginStatus: (state) => state.loginStatus,
  getLoginData: (state) => state.loginData,
  getAccessToken: (state) => state.accessToken,
  getRefreshToken: (state) => state.refreshToken,
  getRecruitment: (state) => state.recruitment,
  getAssessment: (state) => state.assessment,
  getCandidate: (state) => state.candidate,
  getTraining: (state) => state.training,
  getCollege: (state) => state.collegeDashboard,
  getRedirectBack: (state) => state.redirectBack,
  getResumeuuid: (state) => state.resumeClinicuuid,
  getNewUserUsingUUID: (state) => state.newUserUsingUUID,
  getResumejobid: (state) => state.resumeJobid,
};

const actions = {
  async getPreferences(state, data) {
    try {
      const response = await getPreference();
      if (response.status == 200) {
        state.commit("setPreference", response.data.data);
      }
      state.dispatch("checkCookie", data);
    } catch (error) {
      state.dispatch("checkCookie", data);
      console.log(error);
    }
  },
  login(state, userInfo) {
    return new Promise((resolve, reject) => {
      userLogin(userInfo.keycloak, {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      })
        .then((response) => {
          const data = response.data;
          if (data.access_token) {
            state.commit("setToken", data.access_token);
            state.commit("setRefreshToken", data.refresh_token);
            resolve(response);
          } else {
            reject(data);
          }
          return response;
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  saveAccess(state, data) {
    // document.cookie = `refreshToken=${state.getters.getRefreshToken};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    // document.cookie = `accessToken=${state.getters.getAccessToken};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    document.cookie = `refreshToken=${state.getters.getRefreshToken};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    document.cookie = `accessToken=${state.getters.getAccessToken};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    const { details, flag, loginData, mobaccess } = data;
    state.commit("setLoginData", loginData);
    for (let i in details) {
      if (details[i].project === "assessment") {
        state.commit("setAssessment", details[i]);
      } else if (details[i].project === "recruitment") {
        state.commit("setRecruitment", details[i]);
      } else if (details[i].project === "candidate") {
        state.commit("setCandidate", details[i]);
      } else if (details[i].project === "collegeDashboard") {
        state.commit("setCollege", details[i]);
      } else if (details[i].project === "training") {
        state.commit("setTraining", details[i]);
      }
    }
    state.dispatch("getPreferences", data);
  },
  goToPage(state, value) {
    if (state.getters.getNotificationRedirect) {
      state.dispatch("goToNotification");
    }
    else {
      state.dispatch("redirectOnAccess", value);
    }
  },
  redirectOnAccess(state, value) {
    let project = typeof value === "object" ? value.value : value;
    let uuid = typeof value === "object" ? value.panelId : null;
    if (Object.keys(state.getters.getTrainingRedirect).length == 2) {
      // window.location.replace(`http://localhost:8082/training/${state.getters.getTrainingRedirect.redirect}/${state.getters.getTrainingRedirect.courseID}`);
      window.location.replace(
        `https://candidate.hire3x.com/training/${state.getters.getTrainingRedirect.redirect}/${state.getters.getTrainingRedirect.courseID}`
      );
    } else if (project === "candidate") {
      // window.location.replace("http://localhost:8083?from=candidate");
      // uuid
      if (state.getters.getResumeuuid && state.getters.getResumejobid) {
        const jobid = state.getters.getResumejobid;
        const uuid = state.getters.getResumeuuid;
        state.commit("setresumeClinicuid", null);
        state.commit("setresumeJobid", null);
        window.location.replace(
          `https://candidate.hire3x.com?from=candidate&resumeJobid=${jobid}&uuid=${uuid}`
        );
      }
      else if (state.getters.getResumeuuid) {
        const uuid = state.getters.getResumeuuid;
        state.commit("setresumeClinicuid", null);
        window.location.replace(
          `https://candidate.hire3x.com?from=candidate&uuid=${uuid}`
        );
      } else if (state.getters.getNewUserUsingUUID) {
        const newUserUsingUUID = state.getters.getNewUserUsingUUID;
        state.commit("setNewUserUsingUUID", null);
        window.location.replace(
          `https://candidate.hire3x.com?fromWebsite=${newUserUsingUUID}`
        );
      }
      window.location.replace(
        `https://candidate.hire3x.com/?from=candidate`
      );
      // window.location.href=
      //   "http://192.168.100.104:8081/?from=candidate"
      // ;
    } else if (project === "recruitment") {
      if (uuid) {
        console.log("panel logged in");
        // window.location.replace(`http://localhost:8081/jobs/paneldetails/?uuid=${uuid}&panel=true`);
        window.location.replace(
          `https://recruitment.hire3x.com/jobs/paneldetails/?uuid=${panelId}&panel=true`
        );
      }
      else if (state.getters.getPageRedirect) {
        if (typeof state.getters.getPageRedirect === 'object' && state.getters.getPageRedirect.intid) {
          // window.location.replace(`http://localhost:8081/jdflow/botanalysis/?intid=${state.getters.getPageRedirect.intid}&type=${state.getters.getPageRedirect.type}`);
          window.location.replace(`https://recruitment.hire3x.com/jdflow/botanalysis/?intid=${state.getters.getPageRedirect.intid}&type=${state.getters.getPageRedirect.type}`);
        }
        // window.location.replace(`http://localhost:8081${state.getters.getPageRedirect}?from=login`);
        else window.location.replace(`https://recruitment.hire3x.com${state.getters.getPageRedirect}?from=login`);
      } else {
        // window.location.replace("http://localhost:8081");
        window.location.replace("https://recruitment.hire3x.com");
      }
    } else if (project === "assessment") {
      // window.location.replace("http://localhost:8082");
      window.location.replace("https://judge.hire3x.com");
    } else if (project === "training") {
      // window.location.replace("http://localhost:8082?from=login");
      window.location.replace(
        "https://trainingadmin.hire3x.com?from=login"
      );
    } else if (project === "collegeDashboard") {
      // window.location.replace("http://localhost:8085");
      window.location.replace(
        "https://college.hire3x.com?from=login"
      );
    }
  },
  redirectOnLogin(state, data) {
    // if(flag!=='no-redirect'){
    // document.cookie=`refreshToken=${state.getters.getRefreshToken};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    // document.cookie=`accessToken=${state.getters.getAccessToken};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    // document.cookie = `loginData=${JSON.stringify(state.getters.getLoginData)};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    const college = state.getters.getCollege || {};
    if (Object.keys(state.getters.getTrainingRedirect).length == 2) {
      // window.location.replace(`http://localhost:8082/training/${state.getters.getTrainingRedirect.redirect}/${state.getters.getTrainingRedirect.courseID}`);
      window.location.replace(
        `https://candidate.hire3x.com/training/${state.getters.getTrainingRedirect.redirect}/${state.getters.getTrainingRedirect.courseID}`
      );
    } else if (
      state.getters.getLoginData.type == "panel" &&
      (Object.keys(state.getters.getRecruitment).length > 0 ||
        Object.keys(state.getters.getRecruitment).length == 0)
    ) {
      // window.location.replace(`http://localhost:8083/jobs/paneldetails/?uuid=${state.getters.getPanelId}&panel=true`);
      window.location.replace(
        `https://recruitment.hire3x.com/jobs/paneldetails/?uuid=${state.getters.getPanelId}&panel=true`
      );
    } else if (
      data.flag === "Panelist" &&
      Object.keys(state.getters.getRecruitment).length > 0
    ) {
      // window.location.replace("http://localhost:8083?from=recruitment&type=admin");
      window.location.replace("https://recruitment.hire3x.com");
    } else if (
      data.flag === "assessment" &&
      Object.keys(state.getters.getAssessment).length > 0
    ) {
      // window.location.replace("http://localhost:8082?from=assessment");
      window.location.replace(
        "https://judge.hire3x.com?from=assessment"
      );
      // state.commit('setAssessmentWindow',data);
      // setTimeout(()=>{
      //     data.close();
      // },5000);
    } else if (
      data.flag === "recruitment" &&
      Object.keys(state.getters.getRecruitment).length > 0
    ) {
      if (state.getters.getPageRedirect) {
        if (typeof state.getters.getPageRedirect === 'object' && state.getters.getPageRedirect.intid) {
          // window.location.replace(`http://localhost:8081/jdflow/botanalysis/?intid=${state.getters.getPageRedirect.intid}&type=${state.getters.getPageRedirect.type}`);
          window.location.replace(`https://recruitment.hire3x.com/jdflow/botanalysis/?intid=${state.getters.getPageRedirect.intid}&type=${state.getters.getPageRedirect.type}`);
        }
        // else window.location.replace(`http://localhost:8081${state.getters.getPageRedirect}`);
        else window.location.replace(`https://recruitment.hire3x.com${state.getters.getPageRedirect}`);
      }
      else {
        // window.location.replace("http://localhost:8083?from=recruitment&type=admin");
        window.location.replace("https://recruitment.hire3x.com");
      }
    } else if (data.flag === "candidate") {
      if (state.getters.getPageRedirect) {
        // window.location.replace(`http://localhost:8083${state.getters.getPageRedirect}`);
        window.location.replace(
          `https://candidate.hire3x.com${state.getters.getPageRedirect}`
        );
      }
      else if (state.getters.getResumejobid && state.getters.getResumeuuid) {
        const jobid = state.getters.getResumejobid;
        const uuid = state.getters.getResumeuuid;
        state.commit("setresumeClinicuid", null);
        state.commit("setresumeJobid", null);
        window.location.replace(
          `https://candidate.hire3x.com?from=candidate&resumeJobid=${jobid}&uuid=${uuid}`
        );
      }
      else if (state.getters.getResumeuuid) {
        const uuid = state.getters.getResumeuuid;
        state.commit("setresumeClinicuid", null);
        window.location.replace(
          `https://candidate.hire3x.com?from=candidate&uuid=${uuid}`
        );
        // window.location.replace(`https://candidate.hire3x.com/?uuid=${state.getters.getResumeuuid}`);
      } else if (state.getters.getNewUserUsingUUID) {
        const newUserUsingUUID = state.getters.getNewUserUsingUUID;
        state.commit("setNewUserUsingUUID", null);
        window.location.replace(
          `https://candidate.hire3x.com?fromWebsite=${newUserUsingUUID}`
        );
      } else if (Object.keys(state.getters.getCandidateRedirect).length == 2) {
        // window.location.replace(`http://localhost:8084/${state.getters.getCandidateRedirect.to}?jobID=${state.getters.getCandidateRedirect.jobID}`);
        window.location.replace(
          `https://candidate.hire3x.com/${state.getters.getCandidateRedirect.to}?jobID=${state.getters.getCandidateRedirect.jobID}`
        );
      } else if (Object.keys(state.getters.getCandidateRedirect).length == 1) {
        // window.location.replace(`http://localhost:8084/${state.getters.getCandidateRedirect.to}`);
        window.location.replace(
          `https://candidate.hire3x.com/${state.getters.getCandidateRedirect.to}`
        );
      } else if (data.mobaccess) {
        if (
          !data.mobaccess.includes(state.getters.getPreference.defaultModule)
        ) {
          if (data.mobaccess.includes("candidate")) {
            // window.location.replace("http://localhost:8084?from=recruitment&type=candidate");
            window.location.replace(
              "https://candidate.hire3x.com?from=candidate"
            );
          } else if (data.mobaccess.includes("recruitment")) {
            // window.location.replace("http://localhost:8083?from=admin&type=admin");
            window.location.replace("https://recruitment.hire3x.com");
          }
        } else {
          if (state.getters.getPreference.defaultModule == "candidate") {
            // window.location.replace("http://localhost:8084?from=recruitment&type=candidate");
            window.location.replace(
              "https://candidate.hire3x.com?from=candidate"
            );
          } else if (
            state.getters.getPreference.defaultModule == "recruitment"
          ) {
            // window.location.replace("http://localhost:8083?from=admin&type=admin");
            window.location.replace("https://recruitment.hire3x.com");
          }
        }
      } else {
        // window.location.replace("http://localhost:8084?from=recruitment&type=candidate");
        window.location.replace(
          "https://candidate.hire3x.com?from=candidate"
        );
      }

      // console.log("Candidate");
    } else if (
      data.flag === "builder" &&
      Object.keys(state.getters.getCandidate).length > 0
    ) {
      // window.location.replace("http://localhost:8085");
      window.location.replace("https://builder.hire3x.com/");
      // console.log("Candidate");
    } else if (
      data.flag === "training" &&
      Object.keys(state.getters.getTraining).length > 0
    ) {
      // window.location.replace("http://localhost:8082?from=login");
      window.location.replace(
        "https://trainingadmin.hire3x.com?from=login"
      );
    } else if (
      data.flag === "collegeDashboard" &&
      Object.keys(college).length > 0
    ) {
      // window.location.replace("http://localhost:8085");
      window.location.replace(
        "https://college.hire3x.com?from=login"
      );
    } else if (data.flag === "admin") {
      if (
        Object.keys(state.getters.getPreference).length > 0 &&
        state.getters.getPreference.defaultModule != null &&
        state.getters.getPreference.defaultModule != "candidate" &&
        getAccessProjects().includes(state.getters.getPreference.defaultModule)
      ) {
        if (state.getters.getPreference.defaultModule == "assessment") {
          // window.location.replace("http://localhost:8082?from=admin&type=admin");
          window.location.replace(
            "https://judge.hire3x.com?from=admin&type=admin"
          );
        } else if (state.getters.getPreference.defaultModule == "recruitment") {
          //    window.location.replace("http://localhost:8083?from=admin&type=admin");
          window.location.replace("https://recruitment.hire3x.com");
        } else if (
          state.getters.getPreference.defaultModule == "collegeDashboard"
        ) {
          // window.location.replace("http://localhost:8085?from=admin&type=admin");
          window.location.replace(
            "https://college.hire3x.com?from=login"
          );
        } else if (state.getters.getPreference.defaultModule == "training") {
          // window.location.replace("http://localhost:8082?from=login");
          window.location.replace(
            "https://trainingadmin.hire3x.com?from=login"
          );
        }
      } else {
        if (Object.keys(state.getters.getAssessment).length > 0) {
          // window.location.replace("http://localhost:8082?from=admin&type=admin");
          window.location.replace(
            "https://judge.hire3x.com?from=admin&type=admin"
          );
        } else if (Object.keys(state.getters.getRecruitment).length > 0) {
          // window.location.replace("http://localhost:8083?from=admin&type=admin");
          window.location.replace("https://recruitment.hire3x.com");
        } else if (Object.keys(state.getters.getCollege).length > 0) {
          // window.location.replace("http://localhost:8085?from=admin&type=admin");
          window.location.replace(
            "https://college.hire3x.com?from=login"
          );
        } else if (Object.keys(state.getters.getTraining).length > 0) {
          // window.location.replace("http://localhost:8082?from=login");
          window.location.replace(
            "https://trainingadmin.hire3x.com?from=login"
          );
        } else if (Object.keys(state.getters.getCandidate).length > 0) {
          if (state.getters.getResumejobid && state.getters.getResumeuuid) {
            const jobid = state.getters.getResumejobid;
            const uuid = state.getters.getResumeuuid;
            state.commit("setresumeClinicuid", null);
            state.commit("setresumeJobid", null);
            window.location.replace(
              `https://candidate.hire3x.com?from=candidate&resumeJobid=${jobid}&uuid=${uuid}`
            );
          }
          else if (state.getters.getResumeuuid) {
            const uuid = state.getters.getResumeuuid;
            state.commit("setresumeClinicuid", null);
            window.location.replace(
              `https://candidate.hire3x.com?from=candidate&uuid=${uuid}`
            );
          } else if (state.getters.getNewUserUsingUUID) {
            const newUserUsingUUID = state.getters.getNewUserUsingUUID;
            state.commit("setNewUserUsingUUID", null);
            window.location.replace(
              `https://candidate.hire3x.com?fromWebsite=${newUserUsingUUID}`
            );
          }
          // window.location.replace("http://localhost:8084?from=admin&type=candidate");
          window.location.replace(
            "https://candidate.hire3x.com?from=candidate"
          );
        }
      }
    }
    // }
  },
  goToNotification(state, from, data) {
    let notObject = JSON.parse(JSON.stringify(state.getters.getNotificationRedirect));
    let projects = ["Candidate", "Training", "Recruitment", "Training-Candidate"];
    if (projects.includes(notObject.project)) {
      let url = getProjectUrl(notObject.project);
      state.commit("setNotificationRedirect", null);
      window.location.replace(url + notObject.link);
    }
    else {
      state.commit("setNotificationRedirect", null);
      if (from == 'login') state.dispatch("redirectOnLogin", data);
      else state.dispatch("redirectOnAccess", value);
    }
  },
  checkCookie(state, data) {
    state.commit("setLoginStatus", true);
    state.commit(
      "setUserName",
      jwt_decode(state.getters.getAccessToken).given_name
    );
    if (state.getters.getMobileToken) {
      //   document.cookie = `mobileToken=${JSON.stringify(
      //   state.getters.getMobileToken
      // )};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      document.cookie = `mobileToken=${JSON.stringify(state.getters.getMobileToken)};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    }
    document.cookie = `loginData=${JSON.stringify(
      state.getters.getLoginData
    )};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    if (Object.keys(state.getters.getAssessment).length > 0) {
      document.cookie = `assessment=${JSON.stringify(
        state.getters.getAssessment
      )};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      // document.cookie = `assessment=${JSON.stringify(state.getters.getAssessment)};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    } else {
      document.cookie = `assessment=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      // document.cookie = `assessment=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    }
    if (Object.keys(state.getters.getRecruitment).length > 0) {
      document.cookie = `recruitment=${JSON.stringify(
        state.getters.getRecruitment
      )};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      // document.cookie = `recruitment=${JSON.stringify(state.getters.getRecruitment)};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    } else if (state.getters.getLoginData.type == "panel") {
      document.cookie = `recruitment=ExternalPanelist;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      // document.cookie = `recruitment=ExternalPanelist;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    } else {
      document.cookie = `recruitment=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      // document.cookie = `recruitment=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    }
    if (Object.keys(state.getters.getCandidate).length > 0) {
      document.cookie = `candidate=${JSON.stringify(
        state.getters.getCandidate
      )};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      // document.cookie = `candidate=${JSON.stringify(state.getters.getCandidate)};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    } else {
      document.cookie = `candidate=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      // document.cookie = `candidate=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    }
    if (Object.keys(state.getters.getTraining).length > 0) {
      document.cookie = `training=${JSON.stringify(
        state.getters.getTraining
      )};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      // document.cookie = `training=${JSON.stringify(state.getters.getTraining)};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    } else {
      // document.cookie = `training=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      document.cookie = `training=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    }
    const college = state.getters.getCollege || {};
    if (Object.keys(college).length > 0) {
      document.cookie = `collegeDashboard=${JSON.stringify(
        college
      )};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      // document.cookie = `collegeDashboard=${JSON.stringify(college)};expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    } else {
      // document.cookie = `collegeDashboard=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
      document.cookie = `collegeDashboard=no-access;expires=Wed, 16 Jan 2030 12:00:00 UTC;path=/;domain=hire3x.com;`;
    }
    if(state.getters.getNotificationRedirect){
        state.dispatch("goToNotification", 'login', data);
    }
    else state.dispatch("redirectOnLogin", data);
  }
}

const mutations = {
  setNewUserUsingUUID(state, data) {
    state.newUserUsingUUID = data;
  },
  setresumeJobid(state, jobId) {
    state.resumeJobid = jobId;
  },
  setresumeClinicuid(state, uuid) {
    state.resumeClinicuuid = uuid;
  },
  setUserData(state, token) {
    state.userData = token;
  },
  setPageRedirect(state, token) {
    state.pageredirect = token;
  },
  setCandidateRedirect(state, token) {
    state.candidateRedirect = token;
  },
  setTrainingRedirect(state, token) {
    state.trainingRedirect = token;
  },
  setLoginData(state, token) {
    state.loginData = token;
  },
  setPanelId(state, token) {
    state.paneluuid = token;
  },
  setPreference(state, token) {
    state.preference = token;
  },
  setToken(state, token) {
    state.accessToken = token;
  },
  setRefreshToken(state, token) {
    state.refreshToken = token;
  },
  setRecruitment(state, data) {
    state.recruitment = data;
  },
  setAssessment(state, data) {
    state.assessment = data;
  },
  setCandidate(state, data) {
    state.candidate = data;
  },
  setTraining(state, data) {
    state.training = data;
  },
  setCollege(state, data) {
    state.collegeDashboard = data;
  },
  setLoginStatus(state, data) {
    state.loginStatus = data;
  },
  setUserName(state, data) {
    state.loggedUserName = data;
  },
  setRedirectBack(state, data) {
    state.redirectBack = data;
  },
  setMobileToken(state, data) {
    state.mobileToken = data;
  },
  setNotificationRedirect(state, data) {
    state.notificationRedirect = data;
  },
  // setAssessmentWindow(state,data){
  //     state.assessmenWindow=data;
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
